import { useState } from "react";
import { ThemeProvider } from "@mui/material";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AppSnackbar } from "src/lib/components/complex/Snackbar";
import { customTheme } from "src/lib/styles/theme";
import { DashboardShell } from "src/parts/DashboardShell";
import { seedDesignState } from "./seedDesignState";

const DesignApp = () => {
    const [ready] = useState(() => {
        seedDesignState();
        return true;
    });

    if (!ready) {
        return null;
    }

    return (
        <ThemeProvider theme={customTheme}>
            <BrowserRouter>
                <Routes>
                    <Route path="*" element={<DashboardShell />} />
                </Routes>
                <AppSnackbar />
            </BrowserRouter>
        </ThemeProvider>
    );
};

export { DesignApp };
